if (!customElements.get('op-product-gallery-pagination')) {
    class OpProductGalleryPagination extends HTMLElement {
        constructor() {
            super();
            this.swiper = this.closest('op-swiper');
            this.currentSlideEl = this.querySelector("[data-current-slide]");

            if (!this.currentSlideEl) {
                console.error('op-product-gallery-pagination must contain an element with dataset "data-current-slide"');
                return;
            }

            if (!this.swiper) {
                console.error('op-product-gallery-pagination must be a child of op-swiper');
                return;
            }
        }

        connectedCallback() {
            this.swiper.addEventListener('slideChanged', (event) => {
                this.currentSlideEl.innerText = event.detail.activeIndex + 1;
            });
        }
    }
    customElements.define("op-product-gallery-pagination", OpProductGalleryPagination);
}